export default "__VITE_ASSET__DRNvJKPS__"